/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Icon/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import LockIcon from './LockIcon/index'
import No from './No/index'
import React from 'react'
import UnlockIcon from './UnlockIcon/index'



/** @type {import('Simple/types.js').View} */
export default function Icon({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Payors/Payor/PaymentPlanLength/LockAction/Icon"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let payorLockValueData = fromData.useDataFormat({ viewPath,
context: 'payor',
path: 'lock',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: payorLockValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'LockIcon'}>
<LockIcon
  viewPath={`${viewPath}/LockIcon`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'UnlockIcon'}>
<UnlockIcon
  viewPath={`${viewPath}/UnlockIcon`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}